import { Button } from '@insify/design-system/components';
import { IconicSparkles2 } from '@insify/design-system/iconic-icons';
import { headingSm, textMd, textXsSemibold } from '@insify/design-system/typography';
import { ContentContextWrapper } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import styles from './AssistantAnnouncementBanner.module.css';
import bannerImg from './safetynet.png';

export const AssistantAnnouncementBanner: React.FC = () => {
  const navigate = useNavigate();

  const handleStartChat = () => {
    navigate('/my-safety-net');
  };

  return (
    <ContentContextWrapper id='assistant-announcement-banner'>
      <div className={styles.banner}>
        <div className={styles.inner}>
          <div className={styles.cta}>
            <div className={styles.ctaHeader}>
              <div className={styles.pill}>
                <IconicSparkles2 className={styles.pillIcon} />
                <span className={clsx(textXsSemibold, styles.pillText)}>NIEUW</span>
              </div>
              <div className={styles.ctaText}>
                <span className={headingSm}>Creëer slim inzicht in je financiële situatie </span>
                <span className={clsx(textMd, styles.ctaDescription)}>
                  Ontdek samen met de Insify product genius waar je echt aan moet denken als ondernemer.
                </span>
              </div>
            </div>
            <div>
              <ul className={styles.ctaList}>
                <li>Hoe ziet mijn financiële vangnet bij inkomensverlies eruit?</li>
                <li>Heb ik recht op bijstand?</li>
              </ul>
            </div>
            <Button
              type='button'
              kind='secondary'
              trackingId='start-chat'
              className={styles.ctaButton}
              onClick={handleStartChat}
              rightIcon={<div className={styles.avatar} />}
            >
              Start chat met product genius ⚡️
            </Button>
          </div>
          <img src={bannerImg} alt='Assistant Announcement' className={styles.image} />
        </div>
      </div>
    </ContentContextWrapper>
  );
};
